import {useCallback} from 'react'
import {AtUri} from '@atproto/api'

import {useOpenLink} from '#/lib/hooks/useOpenLink'
import {TRANSLATION_SERVICE_URL} from '#/env/common'

export function useServiceTranslate() {
  const openLink = useOpenLink()

  return useCallback(
    (postUri: string, targetLangCode: string) => {
      const urip = new AtUri(postUri)
      const url = `${TRANSLATION_SERVICE_URL}?did=${urip.hostname}&collection=app.bsky.feed.post&rkey=${urip.rkey}&target_lang=${targetLangCode}`
      void openLink(url)
    },
    [openLink],
  )
}
